module.exports = __webpack_public_path__ + "media/scanOk.efab3f17.mp3";